export default __webpack_public_path__ + "static/media/facebook-icon.a2207b67.svg";